export default __webpack_public_path__ + "static/media/Prancheta 4.1ea61dfc.svg";